<template>
  <div id="form">
    <img id = "sketch" src="@/assets/AufbauOhrSkizzeleer.jpg"/>

    <input id = "input1" v-model="message1" placeholder="Feld1" />
    <input id = "input2" v-model="message2" placeholder="Feld2" />
    <input id = "input3" v-model="message3" placeholder="Feld3" />
    <input id = "input4" v-model="message4" placeholder="Feld4" />
    <input id = "input5" v-model="message5" placeholder="Feld5" />
    <input id = "input6" v-model="message6" placeholder="Feld6" />
    <input id = "input7" v-model="message7" placeholder="Feld7" />
    <input id = "input8" v-model="message8" placeholder="Feld8" />
    <input id = "input9" v-model="message9" placeholder="Feld9" />

    <button id = "showlsg" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong">Beispiellösung</button>

            <!-- Modal -->
            <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Mögliche Lösung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <img id = "lsg" src="@/assets/AufbauOhrSkizzeLsg.jpg"/>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>

  </div>
</template>

<style scoped>
#sketch {
    width: 75%;
}
#showlsg {
    position: absolute;
    left: 630px;
    top: 670px
}
.modal-content {
    width: 1100px;
}
#lsg {
    width: 100%
}

input {
    position: absolute;
}
#input1 {
    left: 260px;
    top: 105px
}
#input2 {
    left: 470px;
    top: 205px
}
#input3 {
    left: 570px;
    top: 135px
}
#input4 {
    left: 700px;
    top: 90px
}
#input5 {
    left: 880px;
    top: 210px
}
#input6 {
    left: 965px;
    top: 480px
}
#input7 {
    left: 740px;
    top: 540px
}
#input8 {
    left: 520px;
    top: 550px
}
#input9 {
    left: 300px;
    top: 480px
}

#button2 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form {
    height: 1000px;;
}
</style>